import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {customersApi} from "@/store/api/v1/customers";

export const creditsApi = createApi({
    reducerPath: 'creditsApi',
    tagTypes: ['credits'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        storeCredit: build.mutation({
            query: (data) => ({
                url: api.credits.storeCredit(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled;
                    dispatch(
                        customersApi.util.updateQueryData('getCustomers', patch, (draft) => {
                            const index = draft.findIndex((customer) => customer.id === patch.user_id);
                            if (index !== -1) {
                                draft[index] = {...draft[index], credits: [data]};
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
        getCreditHistory: build.query({
            query: ({id, ...data}) => ({
                url: api.credits.getCreditHistory(id),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
        }),
    })
})

export const {useLazyGetCreditHistoryQuery, useStoreCreditMutation} = creditsApi